module.exports = __webpack_public_path__ + "assets/img/triangleIcon-b5d614ff.png";